import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Pause } from 'lucide-react';
import { useTimer } from '../hooks/TimerContext';
import { SESSION } from '../pages/TimerPage';

/** Small floating timer pill (bottom-right) shown while a session is active. */
export function FloatingPill() {
  const t = useTimer();
  const navigate = useNavigate();
  const running = t.status === 'running';
  const session = SESSION[t.sessionType];

  return (
    <div
      onClick={() => navigate('/timer')}
      className="animate-fade-up"
      style={{
        position: 'fixed', right: 22, bottom: 'max(22px, env(safe-area-inset-bottom))',
        zIndex: 45, display: 'flex', alignItems: 'center', gap: 12,
        background: 'var(--bg-elev)', border: '0.5px solid var(--border)',
        borderRadius: 40, padding: '8px 8px 8px 18px', boxShadow: 'var(--shadow)', cursor: 'pointer',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
        <span style={{ fontSize: 18, fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>{t.display}</span>
        <span style={{ fontSize: 10, fontWeight: 600, color: session.color, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{session.label}</span>
      </div>
      <button
        onClick={(e) => { e.stopPropagation(); running ? t.pause() : t.status === 'paused' ? t.resume() : t.start(t.taskId); }}
        style={{ width: 40, height: 40, borderRadius: '50%', border: 'none', cursor: 'pointer', background: session.color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        {running ? <Pause size={18} fill="#fff" /> : <Play size={18} fill="#fff" style={{ marginLeft: 2 }} />}
      </button>
    </div>
  );
}
